import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchList } from 'services/entities/duck';
import DropdownTreeSelect from 'react-dropdown-tree-select';
import 'styles/react-dropdown-tree-select/styles.css';
import fastMemoize from 'fast-memoize';

class EntityTreeSelectContainer extends Component {
    constructor(props) {
        super(props);
        this.focused = false;
        this.state = {
            inputValue: null
        };
        this.onBlur = this.onBlur.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.generateSortedData = fastMemoize(EntityTreeSelectContainer.generateSortedData);
    }

    static getDerivedStateFromProps(props, state) {
        const inputValuesNotEqual = props.input.value !== state.inputValue;
        if (inputValuesNotEqual) {
            return {
                inputValue: props.input.value,
            };
        }
        return null;
    }

    shouldComponentUpdate = () => !this.focused;

    onFocus() {
        this.focused = true;
    }

    onBlur(input) {
        this.focused = false;
        this.setState({
            inputValue: input.value
        });
    }

    onChange(input, currentNode, selectedNodes) {
        if (selectedNodes) {
            const resolvedNodes = selectedNodes.map(node => node.value);
            input.onChange(resolvedNodes);
        }
    }

    static formatEntitiesList(list, props) {
        const { filterSelf, filterChildren, entityId } = props;
        let entitiesList = list;

        if (filterSelf) {
            entitiesList = entitiesList.filter(e => e.id !== entityId);
        }
        if (filterChildren) {
            entitiesList = entitiesList.filter(e => !e.parentEntities.includes(entityId));
        }

        entitiesList = entitiesList.map(e => ({ label: e.name, value: e.id }));

        return entitiesList;
    }

    static generateSortedData(list, inputValue, props) {
        if (list) {
            const data = EntityTreeSelectContainer.formatEntitiesList(list, props);
            let sortedData = data.sort(EntityTreeSelectContainer.compare);
            sortedData = EntityTreeSelectContainer.selectNodes(sortedData, inputValue);
            return sortedData;
        }

        return null;
    }

    static selectNodes(data, inputValue) {
        if (inputValue) {
            for (let i = 0; i < inputValue.length; i += 1) {
                for (let j = 0; j < data.length; j += 1) {
                    const node = data[j];
                    if (node.value === inputValue[i]) {
                        node.checked = true;
                    }
                }
            }
        }
        return data;
    }

    static compare(a, b) {
        if (a.label.toUpperCase() < b.label.toUpperCase()) {
            return -1;
        }
        if (a.label.toUpperCase() > b.label.toUpperCase()) {
            return 1;
        }
        return 0;
    }

    componentDidMount() {
        this.props.fetchList();
    }

    render() {
        const { input, list } = this.props;
        const data = this.generateSortedData(list, input.value, this.props);

        if (data && data.length) {
            return (
                <DropdownTreeSelect
                    data={data}
                    onChange={this.onChange.bind(this, input)}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur.bind(this, input)}
                />
            );
        }

        return null;
    }
}

const mapStateToProps = state => ({
    list: state.entities.list
});

export { EntityTreeSelectContainer as __InternalClass };

export default connect(mapStateToProps, { fetchList })(EntityTreeSelectContainer);



// WEBPACK FOOTER //
// ./src/containers/EntityTreeSelectContainer.js